import * as React from 'react';
import * as Dati from '../../Dati';
import { BasePureComponent } from '../BaseComponent';
import { Trad } from '../../components/';

interface IAddendumDataMultiInfo {
    Data: Dati.CAppendiceDati;
    RenderFormField: any;
}

export class AddendumDataMultiInfo extends BasePureComponent<IAddendumDataMultiInfo> {
    public constructor(props: any) {
        super(props);
    }

    public render() {
        const data = this.props.Data;
        const addendumValue = JSON.parse(data.ValoreAppendice);
        const elementGroup = [];

        elementGroup.push({
            CampoAppendice: addendumValue.CampoAppendice,
            Etichetta: addendumValue.RispostaAperturaQuestionario ? 'SI' : 'NO',
            ID_TipoCampo: 5,
            ValoreAppendice: addendumValue.RispostaAperturaQuestionario
        });

        addendumValue.DatiQuestionario.forEach((question: any) => {
            for (let key in question.items) {
                elementGroup.push({
                    CampoAppendice: key,
                    Etichetta: key,
                    ValoreAppendice: question.items[key]
                });
            }
        });
        return (
            <>
                <label className="form-control-label">{Trad.Trad(data.Etichetta)}</label>
                {elementGroup.map(item => this.props.RenderFormField(item))}
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AddendumList/AddendumDataMultiInfo.tsx